import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PrintComponents from "react-print-components";
import moment from "moment/moment";
import IconButton from "@material-ui/core/IconButton";

import BackLink from "../../HelperComponents/BackLink/BackLink";
import DefaultButton from "../../Buttons/DefaultButton/DefaultButton";
import DialogComponent from "../../HelperComponents/DialogComponent/DialogComponent";
import TransitionedBlock from "../../HelperComponents/TransitionedBlock/TransitionedBlock";
import PopperInfo from "../../HelperComponents/PopperInfo/PopperInfo";
import NoItems from "../../HelperComponents/NoItems/NoItems";
import TwoTableLayout from "../../HelperComponents/TwoTableLayout/TwoTableLayout";
import { SuccessMessage } from "../../HelperComponents/ToastMessages/ToastMessage";

import SearchIcon from "../../../assets/image/search_grey.png";
import CloseDialogIcon from "../../../assets/image/Mask.png";
import EmptyIcon from "../../../assets/image/no_prices.png";
import LogoBlue from "../../../assets/image/logo_blue.png";
import delete_items from "../../../assets/image/delete_items.png";
import ScanSound from "../../DisposalBalances/NewIssue/assets/scan_sound.mp3";
import ScanSoundError from "../../DisposalBalances/NewIssue/assets/scan_error_sound.mp3";

import { searchCompanies } from "../../../actions/disposalBalancesActions";
import {
    getReturnDispatchCandidates,
    createReturnDispatch,
} from "../../../actions/returnDispatchesActions";
import { isArray } from "../../../helpers/functions";

import "../../DisposalBalances/NewIssue/NewIssue.scss";
import "./NewReturnDispatch.scss";

class NewReturnDispatch extends Component {
    state = {
        open: false,
        openPopper: false,
        anchorEl: null,
        value: "",
        articleNumber: "",
        idCompany: null,
        printed: false,
        loading: false,
        now: new Date().toISOString(),
        notFoundError: null,
        cartOrders: [],
        initialGoods: [],
        articleOptions: [],
        openNoItemDialog: false,
        openAlreadyAddedDialog: false,
        anchorElArticle: null,
        openArticlePopper: false,
        openDeleteDialog: false,
        orderToDelete: null,
        successToast: false,
    };

    debounceTimer = null;
    scanAudio = new Audio(ScanSound);
    scanErrorAudio = new Audio(ScanSoundError);

    componentDidMount = () => {
        const { searchCompanies, location } = this.props;
        this.setState({
            anchorEl: document.getElementById("products"),
        });
        searchCompanies();

        const preselected = location && location.state;
        if (preselected && preselected.supplier_id) {
            this.setState({
                value: preselected.supplier_name || "",
                idCompany: preselected.supplier_id,
                openPopper: false,
            });
            this.loadCandidates(preselected.supplier_id);
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        const { idCompany, anchorElArticle, cartOrders, printed } = this.state;

        if (idCompany && !anchorElArticle) {
            const articleElement = document.getElementById("article_input");
            if (articleElement) {
                this.setState({ anchorElArticle: articleElement });
            }
        }

        if (cartOrders !== prevState.cartOrders && printed) {
            this.setState({ printed: false });
        }
    };

    componentWillUnmount = () => {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
    };

    loadCandidates = (supplierId, articleNumber = "") => {
        const { getReturnDispatchCandidates } = this.props;
        return getReturnDispatchCandidates(supplierId, articleNumber).then((res) => {
            if (res.payload && res.payload.data) {
                if (!articleNumber) {
                    this.setState({
                        initialGoods: res.payload.data.positions || [],
                        articleOptions: [],
                    });
                } else {
                    this.setState({
                        articleOptions: res.payload.data.positions || [],
                    });
                }
            } else if (res.error && res.error.response) {
                this.setState({ articleOptions: [] });
            }
            return res;
        });
    };

    onChange = (e) => {
        this.setState({ value: e.target.value });
    };

    onKeyUp = (e) => {
        const value = e.target.value;
        if (value.length > 0 && value.indexOf(" ") === -1) {
            this.setState({ openPopper: true, idCompany: null });
        } else {
            this.setState({ openPopper: false, idCompany: null });
        }
    };

    clickAway = () => {
        this.setState(({ openPopper }) => ({ openPopper: !openPopper }));
    };

    selectProduct = (e) => {
        this.setState({
            value: e.company,
            idCompany: e.id,
            openPopper: false,
            cartOrders: [],
            articleNumber: "",
            initialGoods: [],
            articleOptions: [],
            notFoundError: null,
        });
        this.loadCandidates(e.id);
    };

    onArticleChange = (e) => {
        this.setState({ articleNumber: e.target.value });
    };

    clearArticleField = () => {
        this.setState({ articleNumber: "", articleOptions: [], openArticlePopper: false });
    };

    onArticleKeyUp = (e) => {
        const { idCompany, articleNumber } = this.state;

        if (e.keyCode === 13 && articleNumber.length > 0) {
            this.searchArticle();
            return;
        }

        if (articleNumber.length > 0) {
            this.setState({ openArticlePopper: true });
        } else {
            this.setState({ openArticlePopper: false });
        }

        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }

        if (idCompany && articleNumber.length > 0) {
            this.debounceTimer = setTimeout(() => {
                this.loadCandidates(idCompany, articleNumber);
            }, 500);
        } else if (articleNumber.length === 0) {
            this.setState({ articleOptions: [] });
        }
    };

    clickAwayArticle = () => {
        this.setState({ openArticlePopper: false });
    };

    selectArticle = (article) => {
        this.setState({ articleNumber: article, openArticlePopper: false });
        setTimeout(() => {
            this.searchArticle();
        }, 0);
    };

    searchArticle = () => {
        const { articleNumber, initialGoods, cartOrders } = this.state;
        const { idCompany } = this.state;
        if (!idCompany) return;

        const cartIds = new Set(cartOrders.map((c) => c.related_id));
        const matchesArticle = (item) =>
            item.article_number &&
            item.article_number.toLowerCase() === articleNumber.toLowerCase();

        const exact =
            initialGoods.find((item) => matchesArticle(item) && !cartIds.has(item.related_id)) ||
            initialGoods.find(matchesArticle);

        if (exact) {
            this.addPositionToCart(exact);
            return;
        }

        this.props
            .getReturnDispatchCandidates(idCompany, articleNumber)
            .then((res) => {
                if (res.payload && res.payload.data) {
                    const positions = res.payload.data.positions || [];
                    const found =
                        positions.find((p) => matchesArticle(p) && !cartIds.has(p.related_id)) ||
                        positions.find(matchesArticle);
                    if (found) {
                        this.addPositionToCart(found);
                    } else {
                        this.showNotFound(res.payload.data && res.payload.data.error);
                    }
                } else if (res.error && res.error.response) {
                    this.showNotFound(
                        res.error.response.data && res.error.response.data.error
                    );
                } else {
                    this.showNotFound();
                }
            });
    };

    addPositionToCart = (position) => {
        const { cartOrders } = this.state;

        const alreadyInCart = cartOrders.find(
            (c) => c.related_id === position.related_id
        );
        if (alreadyInCart) {
            this.scanErrorAudio
                .play()
                .catch((err) => console.error("Audio play error:", err));
            this.setState({
                openAlreadyAddedDialog: true,
                articleNumber: "",
                articleOptions: [],
            });
            return;
        }

        const cartItem = { ...position, selectedAmount: position.amount };

        this.scanAudio
            .play()
            .catch((err) => console.error("Audio play error:", err));

        this.setState({
            cartOrders: [...cartOrders, cartItem],
            articleNumber: "",
            articleOptions: [],
            successToast: true,
            notFoundError: null,
        });
    };

    showNotFound = (errorText) => {
        this.scanErrorAudio
            .play()
            .catch((err) => console.error("Audio play error:", err));
        this.setState({
            openNoItemDialog: true,
            notFoundError: errorText || null,
            articleNumber: "",
            articleOptions: [],
        });
    };

    toggleNoItemDialog = () => {
        this.setState((prev) => ({ openNoItemDialog: !prev.openNoItemDialog }));
    };

    toggleAlreadyAddedDialog = () => {
        this.setState((prev) => ({
            openAlreadyAddedDialog: !prev.openAlreadyAddedDialog,
        }));
    };

    handleAddAllToCart = () => {
        const { initialGoods, cartOrders } = this.state;
        if (!initialGoods.length) return;

        const cartIds = new Set(cartOrders.map((c) => c.related_id));
        const newItems = initialGoods
            .filter((g) => !cartIds.has(g.related_id))
            .map((g) => ({ ...g, selectedAmount: g.amount }));

        if (newItems.length === 0) return;

        this.setState({ cartOrders: [...cartOrders, ...newItems] });
    };

    deleteDialog = (order) => {
        this.setState((prev) => ({
            openDeleteDialog: !prev.openDeleteDialog,
            orderToDelete: order || null,
        }));
    };

    deleteOrder = () => {
        const { orderToDelete, cartOrders } = this.state;
        if (!orderToDelete) {
            this.setState({ openDeleteDialog: false });
            return;
        }
        this.setState({
            cartOrders: cartOrders.filter(
                (c) => c.related_id !== orderToDelete.related_id
            ),
            openDeleteDialog: false,
            orderToDelete: null,
        });
    };

    toggleDialog = () => {
        const { printed } = this.state;
        if (printed) {
            this.handlePost();
        } else {
            this.setState(({ open }) => ({ open: !open }));
        }
    };

    cancelDialog = () => {
        this.setState({ open: false, printed: false });
    };

    handlePrint = () => {
        this.setState({ now: new Date().toISOString(), printed: true });
    };

    handleDialogPrint = () => {
        const button = document.getElementById("print_button");
        if (button) button.click();
    };

    handlePost = () => {
        const { createReturnDispatch, history } = this.props;
        const { idCompany, cartOrders } = this.state;

        const data = {
            supplier_id: idCompany,
            return_related_orders: cartOrders.map((order) => ({
                related_id: order.related_id,
            })),
        };

        this.setState({ loading: true });
        createReturnDispatch(data).then((res) => {
            this.setState({ loading: false });
            if (res.payload) {
                history.push("/admin/return-dispatches");
            } else {
                this.setState({ open: false });
            }
        });
    };

    render() {
        const {
            disposal_balances: { companies },
        } = this.props;
        const {
            open,
            openPopper,
            anchorEl,
            value,
            articleNumber,
            idCompany,
            loading,
            now,
            cartOrders,
            initialGoods,
            articleOptions,
            openNoItemDialog,
            openAlreadyAddedDialog,
            openArticlePopper,
            anchorElArticle,
            openDeleteDialog,
            notFoundError,
        } = this.state;

        let items = [];
        if (!!companies && companies.length > 0) {
            items = companies.filter((el) =>
                !!el.company && el.company !== null
                    ? el.company.toLowerCase().includes(value.toLowerCase())
                    : null
            );
        }

        const cartIds = new Set(cartOrders.map((c) => c.related_id));
        const availableGoods = initialGoods.filter(
            (g) => !cartIds.has(g.related_id)
        );

        return (
            <TransitionedBlock>
                <div className="new_issue container">
                    <div className="flex-center-btw title-block-page">
                        <div className="title-page">
                            <BackLink />
                            <h1>Новая выдача возврата</h1>
                        </div>
                    </div>
                    <div className="page_block">
                        <div className="title">Поставщик</div>
                        <div className="search_block">
                            <input
                                id="products"
                                type="text"
                                value={value}
                                onChange={this.onChange}
                                onKeyUp={this.onKeyUp}
                                placeholder="Введите название или телефон компании"
                                autoComplete="off"
                            />
                            <div className="search_buttons">
                                <button className="search-btn">
                                    <img src={SearchIcon} alt="SearchIcon" />
                                </button>
                            </div>
                            <PopperInfo
                                id="products_popper"
                                open={openPopper}
                                anchorEl={anchorEl}
                                clickAway={this.clickAway}
                                position="bottom-start"
                                transition
                            >
                                <ul className="search_transactions_list">
                                    {isArray(items) ? (
                                        items.map((el, idEl) => (
                                            <li
                                                className="search_transactions_item"
                                                onClick={() => this.selectProduct(el)}
                                                key={idEl}
                                            >
                                                <div className="search_transactions_item_head">
                                                    {el.company}
                                                </div>
                                            </li>
                                        ))
                                    ) : (
                                        <li className="search_transactions_no_items">
                                            Компаний не найдено
                                        </li>
                                    )}
                                </ul>
                            </PopperInfo>
                        </div>

                        {idCompany && (
                            <Fragment>
                                <div className="title">Артикул</div>
                                <div className="search_block">
                                    <input
                                        id="article_input"
                                        type="text"
                                        value={articleNumber}
                                        onChange={this.onArticleChange}
                                        onKeyUp={this.onArticleKeyUp}
                                        placeholder="Введите артикул"
                                        autoComplete="off"
                                    />
                                    <div className="search_buttons">
                                        {articleNumber && (
                                            <button
                                                type="button"
                                                className="clear-btn"
                                                onClick={this.clearArticleField}
                                                aria-label="Очистить поле"
                                            >
                                                ×
                                            </button>
                                        )}
                                        <button className="search-btn" onClick={this.searchArticle}>
                                            <img src={SearchIcon} alt="SearchIcon" />
                                        </button>
                                    </div>
                                    <PopperInfo
                                        id="article_popper"
                                        open={openArticlePopper}
                                        anchorEl={anchorElArticle}
                                        clickAway={this.clickAwayArticle}
                                        position="bottom-start"
                                        transition
                                    >
                                        <ul className="search_transactions_list">
                                            {articleOptions.length > 0 ? (
                                                [
                                                    ...new Set(
                                                        articleOptions.map((opt) => opt.article_number)
                                                    ),
                                                ].map((article, idx) => (
                                                    <li
                                                        className="search_transactions_item"
                                                        onClick={() => this.selectArticle(article)}
                                                        key={idx}
                                                    >
                                                        <div className="search_transactions_item_head">
                                                            {article}
                                                        </div>
                                                    </li>
                                                ))
                                            ) : (
                                                <li className="search_transactions_no_items">
                                                    Артикулов не найдено
                                                </li>
                                            )}
                                        </ul>
                                    </PopperInfo>
                                </div>
                            </Fragment>
                        )}

                        {initialGoods.length !== 0 ? (
                            <Fragment>
                                <div className="line_v" />
                                <div className="goods_header">
                                    <div className="goods_controls">
                                        <DefaultButton
                                            variant="outlined"
                                            classes="waiting_for_documents"
                                            onClick={this.handleAddAllToCart}
                                        >
                                            Добавить все
                                        </DefaultButton>
                                    </div>
                                </div>
                                <TwoTableLayout
                                    leftTable={{
                                        title: "Доступно к выдаче",
                                        columns: [
                                            {
                                                title: "Деталь",
                                                style: { width: "40%" },
                                                render: (item) =>
                                                    `${item.article_number} • ${item.manufacturer || item.producer || ""}`,
                                            },
                                            {
                                                title: "Наименование",
                                                style: { width: "40%" },
                                                render: (item) => item.name || "",
                                            },
                                            {
                                                title: "К-во товара",
                                                style: { width: "auto", margin: "0 auto" },
                                                render: (item) => item.amount,
                                            },
                                        ],
                                        data: availableGoods,
                                        emptyMessage: "Все товары добавлены.",
                                        rowKey: "related_id",
                                    }}
                                    rightTable={{
                                        title: "Выбрано к выдаче",
                                        reverse: true,
                                        columns: [
                                            {
                                                title: "Деталь",
                                                style: { width: "35%" },
                                                render: (item) =>
                                                    `${item.article_number} • ${item.manufacturer || item.producer || ""}`,
                                            },
                                            {
                                                title: "Наименование",
                                                style: { width: "35%" },
                                                render: (item) => item.name || "",
                                            },
                                            {
                                                title: "К-во товара",
                                                style: { width: "20%", textAlign: "center" },
                                                render: (item) => item.selectedAmount,
                                            },
                                            {
                                                title: "",
                                                style: {
                                                    width: "10%",
                                                    textAlign: "center",
                                                    cursor: "pointer",
                                                },
                                                render: (item) => (
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            this.deleteDialog(item);
                                                        }}
                                                    >
                                                        <img src={delete_items} alt="delete" />
                                                    </button>
                                                ),
                                            },
                                        ],
                                        data: cartOrders,
                                        emptyMessage: "Список выдачи пуст.",
                                        keyExtractor: (item, idx) => `${item.related_id}_${idx}`,
                                    }}
                                />
                            </Fragment>
                        ) : !!idCompany ? (
                            <NoItems>
                                <div className="box-img">
                                    <img src={EmptyIcon} alt="empty" />
                                </div>
                                <div className="title">Доступных к выдаче товаров не найдено</div>
                            </NoItems>
                        ) : null}

                        {cartOrders.length > 0 ? (
                            <Fragment>
                                <div className="line_v" />
                                <div className="btn_wrapper">
                                    <div>
                                        <DefaultButton onClick={this.toggleDialog}>
                                            Создать выдачу
                                        </DefaultButton>
                                    </div>
                                    <div onClick={this.handlePrint}>
                                        <PrintComponents
                                            trigger={
                                                <button id="print_button" className="print_btn">
                                                    Печать
                                                </button>
                                            }
                                        >
                                            <div className="print_goods">
                                                <div className="print_goods__header">
                                                    <div className="print_goods__header--logo">
                                                        <img src={LogoBlue} alt="Logo" />
                                                    </div>
                                                    <div className="print_goods__header--company">
                                                        {value}
                                                    </div>
                                                </div>
                                                <div className="print_goods__date">
                                                    <span>{moment(now).format("DD.MM.YYYY HH:mm")}</span>
                                                </div>
                                                <div className="print_goods__title" style={{ textAlign: "center" }}>
                                                    Возвратная накладная
                                                </div>
                                                <div className="new_issue_table">
                                                    <div className="table_container transactions_columns return_dispatch_print_table">
                                                        <div className="table_header">
                                                            <div className="table_row">
                                                                <div className="row_item">Дата покупки</div>
                                                                <div className="row_item">Название</div>
                                                                <div className="row_item">Артикул</div>
                                                                <div className="row_item">Производитель</div>
                                                                <div className="row_item">К-во</div>
                                                                <div className="row_item">Цена</div>
                                                                <div className="row_item">Сумма</div>
                                                            </div>
                                                        </div>
                                                        <div className="table_body">
                                                            {cartOrders.map((order, idx) => {
                                                                const price = Number(order.price) || 0;
                                                                return (
                                                                    <div className="table_row" key={idx}>
                                                                        <div className="row_item">
                                                                            {moment(order.purchase_date).format("DD.MM.YYYY")}
                                                                        </div>
                                                                        <div className="row_item">{order.name}</div>
                                                                        <div className="row_item">{order.article_number}</div>
                                                                        <div className="row_item">{order.manufacturer || order.producer || ""}</div>
                                                                        <div className="row_item">{order.selectedAmount}</div>
                                                                        <div className="row_item">{price.toFixed(2)}</div>
                                                                        <div className="row_item">{(price * order.selectedAmount).toFixed(2)}</div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                        <div className="table_container__summary">
                                                            Итого:{" "}
                                                            {cartOrders
                                                                .reduce(
                                                                    (sum, order) =>
                                                                        sum + (Number(order.price) || 0) * order.selectedAmount,
                                                                    0
                                                                )
                                                                .toFixed(2)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </PrintComponents>
                                    </div>
                                </div>
                            </Fragment>
                        ) : null}
                    </div>

                    <DialogComponent open={open} onClose={this.cancelDialog}>
                        <div className="title-dialog">Создать выдачу</div>
                        <div className="descriptions_dialog_component">
                            Вы уверены, что не хотите распечатать отчёт?
                        </div>
                        <div className="btn-wrapper order-dialog-btn more-dialog-btn">
                            <div>
                                <DefaultButton
                                    variant="outlined"
                                    classes="cancel_btn"
                                    onClick={this.cancelDialog}
                                >
                                    Отмена
                                </DefaultButton>
                                <DefaultButton
                                    onClick={this.handlePost}
                                    loading={loading}
                                    disabled={loading}
                                >
                                    Создать
                                </DefaultButton>
                            </div>
                            <div>
                                <button className="print_btn" onClick={this.handleDialogPrint}>
                                    Печать
                                </button>
                            </div>
                        </div>
                        <IconButton
                            classes={{ root: "dialog_close_button" }}
                            onClick={this.cancelDialog}
                        >
                            <img src={CloseDialogIcon} alt="close icon" />
                        </IconButton>
                    </DialogComponent>

                    <DialogComponent
                        open={openNoItemDialog}
                        onClose={this.toggleNoItemDialog}
                    >
                        <div className="title-dialog">Совпадений не найдено</div>
                        <div className="descriptions_dialog_component no_margin">
                            {notFoundError ||
                                "Убедитесь в правильности поискового запроса и повторите попытку."}
                        </div>
                        <div className="btn-wrapper order-dialog-btn">
                            <DefaultButton onClick={this.toggleNoItemDialog}>Ок</DefaultButton>
                        </div>
                        <IconButton
                            classes={{ root: "dialog_close_button" }}
                            onClick={this.toggleNoItemDialog}
                        >
                            <img src={CloseDialogIcon} alt="close icon" />
                        </IconButton>
                    </DialogComponent>

                    <DialogComponent
                        open={openAlreadyAddedDialog}
                        onClose={this.toggleAlreadyAddedDialog}
                    >
                        <div className="title-dialog">Товар уже добавлен</div>
                        <div className="descriptions_dialog_component no_margin">
                            Эта позиция уже добавлена в список выдачи.
                        </div>
                        <div className="btn-wrapper order-dialog-btn">
                            <DefaultButton onClick={this.toggleAlreadyAddedDialog}>
                                Ок
                            </DefaultButton>
                        </div>
                        <IconButton
                            classes={{ root: "dialog_close_button" }}
                            onClick={this.toggleAlreadyAddedDialog}
                        >
                            <img src={CloseDialogIcon} alt="close icon" />
                        </IconButton>
                    </DialogComponent>

                    <DialogComponent
                        open={openDeleteDialog}
                        onClose={() => this.deleteDialog()}
                    >
                        <div className="title-dialog">Удалить товар</div>
                        <div className="descriptions_dialog_component no_margin">
                            Вы уверены, что хотите удалить данный товар из списка?
                        </div>
                        <div className="btn-wrapper order-dialog-btn">
                            <DefaultButton
                                variant="outlined"
                                classes="cancel_btn"
                                onClick={() => this.deleteDialog()}
                            >
                                Отмена
                            </DefaultButton>
                            <DefaultButton onClick={this.deleteOrder}>Удалить</DefaultButton>
                        </div>
                        <IconButton
                            classes={{ root: "dialog_close_button" }}
                            onClick={() => this.deleteDialog()}
                        >
                            <img src={CloseDialogIcon} alt="close icon" />
                        </IconButton>
                    </DialogComponent>

                    {this.state.successToast && (
                        <SuccessMessage
                            close={() => this.setState({ successToast: false })}
                            position="top"
                            message="Товар добавлен"
                            timeout={1500}
                        />
                    )}
                </div>
            </TransitionedBlock>
        );
    }
}

const mapStateToProps = ({ disposal_balances, return_dispatches }) => ({
    disposal_balances,
    return_dispatches,
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            searchCompanies,
            getReturnDispatchCandidates,
            createReturnDispatch,
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(NewReturnDispatch);
